<template>
  <div class="holidayIndex">
    <Header title="请假" type="0" route="/homeIndex"></Header>
    <NOdata
      v-if="this.list && this.list == '[]'"
      title="未查询到辅修数据"
    ></NOdata>
    <div v-else class="content">
      <div class="list-item" v-for="(item, index) in list" :key="index">
        <div class="item-top" @click="apply(item, 0)">
          <p>{{ item.xm }}[{{ item.xh }}]</p>
          <van-row>
            <van-col span="24">
              <ul>
                <li>请假类型：{{ item.qjlxmc }}</li>
                <li>销假状态：{{ item.xjshzt }}</li>
                <li>请假天数：{{ item.qjts }}</li>
                <li>请假时间：{{ item.kssj }} 至 {{ item.jssj }}</li>
              </ul>
            </van-col>
          </van-row>
          <span
            :class="
              item.shzt == '通过'
                ? 'ytgClass'
                : item.shzt == '未通过'
                ? 'btgClass'
                : item.shzt == '审核中'
                ? 'shzClass'
                : 'dssClass'
            "
            >{{ item.shzt }}</span
          >
        </div>
        <div class="operate">
          <span
            @click="apply(item)"
            :class="
              item.shzt == '未通过' || item.shzt == '待送审' ? '' : 'disClass'
            "
            >编辑</span
          >
          <span @click="history(item)">审核记录</span>
          <span
            :class="item.shzt == '通过' ? '' : 'disClass'"
            @click="del(item)"
            >销假</span
          >
        </div>
      </div>
    </div>
    <div class="bottom-btn">
      <button @click="apply">申请</button>
    </div>
  </div>
</template>
<script>
import { Api } from "@/utils/axios";

export default {
  data() {
    return {
      list: []
    };
  },
  methods: {
    async getList() {
      const res = await Api.wdsq_list();
      this.list = res.data;
    },
    apply(item, flag) {
      // 编辑
      if (
        !!item.xsqjid &&
        !(item.shzt == "未通过" || item.shzt == "待送审") &&
        flag != 0
      ) {
        return;
      }
      item.type = flag;
      this.$router.push({
        path: "/holiday/apply",
        query: {
          list: JSON.stringify(item)
        }
      });
    },
    del(item) {
      if (item.shzt == "通过") {
        this.$router.push({
          path: "/holiday/del",
          query: {
            list: item
          }
        });
      }
    },
    history(item) {
      this.$router.push({
        path: "/holiday/history",
        query: {
          list: item
        }
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="less">
.holidayIndex {
  .content {
    height: calc(~"100vh - 110px");
    overflow: auto;
    padding: 0 5% 0;
    .list-item {
      background: #f8f8f8;
      border-radius: 5px;
      margin: 0 auto 5%;
      position: relative;
      .item-top {
        padding: 3% 0 3% 6%;
        p {
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #212f6e;
          letter-spacing: 0;
          font-weight: bolder;
          line-height: 42px;
        }
        ul li {
          font-family: PingFangSC-Light;
          font-size: 12px;
          color: #757da3;
          letter-spacing: 0;
          margin-bottom: 1%;
        }
        span {
          width: 70px;
          height: 42px;
          border-radius: 5px;
          position: absolute;
          top: calc(50% - 30px);
          right: 5%;
          display: inline-flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-family: PingFangSC-Light;
          font-size: 16px;
          letter-spacing: 0;
          line-height: 15px;
        }
        .shzClass {
          color: #7469f8;
        }
        .btgClass {
          color: #f86969;
        }
        .ytgClass {
          color: #12ddd6;
        }
        .dssClass {
          color: #757da3;
        }
      }
      .operate {
        border-top: 1px solid #dee1e9;
        display: block;
        height: 40px;
        line-height: 40px;
        display: flex;
        width: 100%;
        background-color: #ecedfd;
        box-sizing: border-box;
        border-radius: 0 0 5px 5px;
        span {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #212f6e;
          letter-spacing: 0;
          text-align: center;
          flex: 1;
          cursor: pointer;
          &:last-child {
            border-left: 1px solid #dee1e9;
          }
          &:nth-child(2) {
            border-left: 1px solid #dee1e9;
          }
        }
        .disClass {
          color: gray;
          background-color: #f8f8f8;
        }
      }
    }
  }
  .bottom-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    padding-bottom: 10px;
    padding: 0 5%;
    background: #fff;
    box-sizing: border-box;

    button {
      width: 100%;
      height: 44px;
      background: #7469f8;
      border-radius: 3px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/holiday/index.vue